import React, { useState } from "react";
import Swal from "sweetalert2";
import "./auth.css";

export default function AuthPage() {
  const [isLogin, setIsLogin] = useState(true);
  const [form, setForm] = useState({
    name: "",
    username: "",
    email: "",
    password: "",
    confirmPassword: "", // thêm trường xác nhận mật khẩu
    role: "USER",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    if (!isLogin && form.password !== form.confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Lỗi",
        text: "Mật khẩu và xác nhận mật khẩu không khớp!",
      });
      return;
    }

    setLoading(true);

    const endpoint = isLogin
      ? `${baseUrl}/v1/auth/login`
      : `${baseUrl}/v1/auth/register`;

    try {
      const payload = isLogin
        ? {
          username: form.username,
          password: form.password,
        }
        : {
          name: form.name,
          username: form.username,
          email: form.email,
          password: form.password,
          role: form.role,
        };

      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        let errorMessage = "Đã xảy ra lỗi";
        try {
          const errorData = await res.json();
          errorMessage = errorData.message || errorMessage;
        } catch {
          const text = await res.text();
          if (text) errorMessage = text;
        }

        throw new Error(errorMessage);
      }

      const data = await res.json();

      if (isLogin) {
        if (data.access_token && data.refresh_token) {
          localStorage.setItem("jwtToken", data.access_token);
          localStorage.setItem("refreshToken", data.refresh_token);
          localStorage.setItem("user", JSON.stringify(data));

          await Swal.fire({
            icon: "success",
            title: "Đăng nhập thành công!",
            text: `Chào mừng ${data.username}!`,
            timer: 2000,
            showConfirmButton: false,
          });

          window.location.href = "/";
        } else {
          throw new Error("Token không tồn tại trong phản hồi!");
        }
      } else {
        await Swal.fire({
          icon: "success",
          title: "Đăng ký thành công!",
          text: "Bạn có thể đăng nhập ngay bây giờ.",
          timer: 2000,
          showConfirmButton: false,
        });

        setIsLogin(true);
        setForm({
          name: "",
          username: "",
          email: "",
          password: "",
          confirmPassword: "",
          role: "USER",
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Lỗi",
        text: "Tài khoản hoặc mật khẩu không đúng!",
      });
    } finally {
      setLoading(false);
    }
  };


  const switchMode = () => {
    setIsLogin(!isLogin);
    setForm({
      name: "",
      username: "",
      email: "",
      password: "",
      confirmPassword: "",
      role: "USER",
    });
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <h2>{isLogin ? "🎬 Đăng nhập" : "🎟️ Đăng ký"}</h2>
        <form onSubmit={handleSubmit} className="auth-form">
          {!isLogin && (
            <>
              <input
                type="text"
                name="name"
                placeholder="Họ và tên"
                value={form.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={form.email}
                onChange={handleChange}
                required
              />
              <input type="hidden" name="role" value="USER" />
            </>
          )}
          <input
            type="text"
            name="username"
            placeholder="Tên đăng nhập"
            value={form.username}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Mật khẩu"
            value={form.password}
            onChange={handleChange}
            required
          />
          {/* Thêm ô xác nhận mật khẩu khi đăng ký */}
          {!isLogin && (
            <input
              type="password"
              name="confirmPassword"
              placeholder="Xác nhận mật khẩu"
              value={form.confirmPassword}
              onChange={handleChange}
              required
            />
          )}
          <button type="submit" disabled={loading}>
            {loading
              ? isLogin
                ? "🎬 Đang xử lý..."
                : "🎟️ Đang xử lý..."
              : isLogin
                ? "🎬 Đăng nhập"
                : "🎟️ Đăng ký"}
          </button>
        </form>

        <p>
          {isLogin ? "Chưa có tài khoản?" : "Đã có tài khoản?"}{" "}
          <button className="switch-btn" onClick={switchMode}>
            {isLogin ? "Đăng ký ngay" : "Đăng nhập"}
          </button>
        </p>
      </div>
    </div>
  );
}
